import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Companies } from "../../../_shared/interfaces";
import { debounceTime, distinctUntilChanged, filter, Subject, switchMap } from "rxjs";
import { AlertService, IAlertType, RequestsStoreService } from "../../../_shared/services";
import { tap } from "rxjs/operators";
import { ClrDropdownModule } from "@clr/angular";
import { NgForOf, NgIf } from "@angular/common";
import { ClarityIcons, angleIcon } from "@cds/core/icon";

import { environment as env } from '../../../../environments/environment';

@Component({
  selector: 'app-request-company-search',
  standalone: true,
  imports: [
    ClrDropdownModule,
    NgForOf,
    NgIf
  ],
  templateUrl: './request-company-search.component.html',
  styleUrl: './request-company-search.component.sass'
})
export class RequestCompanySearchComponent implements OnInit {

  keyUp$ = new Subject<string>();
  private destroy$ = new Subject<void>();

  onKeyUp(event: Event): void {
    const value = (event.target as HTMLInputElement)?.value || '';
    this.keyUp$.next(value);
  }
  isLoading: boolean = true;
  foundCompanies: Companies[] = [];
  companies: Companies[] = [];

  devMode: boolean = false;

  @Output() submitSupplierNumber = new EventEmitter<Companies>();

  constructor(
    private reqss: RequestsStoreService,
    private alertDispatcher: AlertService,
  ) {
    this.devMode = env.stages.dev;
    ClarityIcons.addIcons(angleIcon)
  }

  ngOnInit() {
    this.keyUp$.pipe(
      filter(term => term.length >= 3),
      debounceTime(300),
      distinctUntilChanged(),
      tap(() => this.isLoading = true),
      switchMap(searchTerm => this.reqss.searchCompany(searchTerm)),
      tap(() => this.isLoading = false)
    )
      .subscribe({
        next: (companies) => {
          if (companies?.object) {
            this.foundCompanies = companies.object;
            if (this.devMode) console.log('Found comppanies:', this.foundCompanies);
          }
        },
        error: (error) => {
          if (this.devMode) console.error(' Error searching components:', error);
          this.alertDispatcher.show({
            message: ' Fehler bei der Lieferantensuche ' + error,
            clrAlertType: IAlertType.DANGER
          }, 2000);
        }
      });
  }

  chooseSupplier(listIndex: number, supplierID: Companies) {
    switch (supplierID.classification) {
      case "C":
        this.alertDispatcher.alertConfig.message = 'Firma ' + supplierID.company + ' ist dauerhaft für Requests und Orders gesperrt (Klassifizierung C)!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
        break;
      default:
        this.alertDispatcher.alertConfig.message = 'All engines running! :) ';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
        if (confirm('Wollen Sie die Firma ' + supplierID.company + ' (ID ' + supplierID.cid + ') als Adressaten übernehmen?')) {
          this.submitSupplierNumber.emit(supplierID);
        }
        break;
    }
  }
}
